
export const generateContent = (domain: string, categories: { 
  other: string[];
  blog: string[];
  products: string[];
  services: string[];
  about: string[];
  technical: string[];
}) => {
  const formatUrl = (url: string) => {
    const path = url.replace(new RegExp(`^https?://(www\.)?${domain}`), '');
    const name = path.split('/').filter(Boolean).pop() || 'Ana Sayfa';
    const formattedName = name
      .replace(/-/g, ' ')
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
    return `- [${formattedName}](${url})`;
  };

  return `# ${domain} llms.txt

# Ana Sayfa ve Genel Bilgiler
${categories.other.map(formatUrl).join('\n')}

${categories.about.length ? `# Kurumsal Sayfalar
${categories.about.map(formatUrl).join('\n')}` : ''}

${categories.blog.length ? `# Blog Sayfaları
${categories.blog.map(formatUrl).join('\n')}` : ''}

${categories.products.length ? `# Ürün Sayfaları
${categories.products.map(formatUrl).join('\n')}` : ''}

${categories.services.length ? `# Hizmet Sayfaları
${categories.services.map(formatUrl).join('\n')}` : ''}

# Teknik Sayfalar
${categories.technical.map(formatUrl).join('\n')}

# Meta Bilgiler
Language: tr-TR
Content-Type: text/plain; charset=utf-8
Last-Modified: ${new Date().toISOString()}
Author: Serhat Demirkan
Author URI: moondiggy.com
Contact: info@${domain}

# AI Tarama Ayarları
Training-Data: partial
Indexing: allow
Cache-Control: 24h
AI-Generated-Content: false
Data-Collection: opt-in`;
};
